(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["shop-lashes-directory"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initializeDirectory = (root = document) => {
      root.querySelectorAll('.wb-lash-directory').forEach((directory) => {
        if (directory.dataset.wbLashReady === 'true') return;
        directory.dataset.wbLashReady = 'true';
        directory.classList.add('wb-lash-directory--motion-ready');

        const rows = directory.querySelectorAll('[data-wb-lash-row]');
        if ('IntersectionObserver' in window) {
          const observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
              if (!entry.isIntersecting) return;
              entry.target.classList.add('is-visible');
              observer.unobserve(entry.target);
            });
          }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
          rows.forEach((row) => observer.observe(row));
        } else {
          rows.forEach((row) => row.classList.add('is-visible'));
        }

        rows.forEach((row) => {
          const track = row.querySelector('[data-wb-lash-track]');
          if (!track) return;
          row.querySelector('[data-wb-lash-previous]')?.addEventListener('click', () => {
            track.scrollBy({ left: -track.clientWidth * 0.86, behavior: 'smooth' });
          });
          row.querySelector('[data-wb-lash-next]')?.addEventListener('click', () => {
            track.scrollBy({ left: track.clientWidth * 0.86, behavior: 'smooth' });
          });
        });
      });
    };

    initializeDirectory();
    document.addEventListener('shopify:section:load', (event) => initializeDirectory(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["winky-lash-club-popup"]) return;
  try {
    
  const initWinkyLashClubPopup = () => {
    const popup = document.getElementById('WinkyLashClubPopup');
    if (!popup || popup.dataset.wblReady === 'true' || typeof popup.showModal !== 'function') return;
    popup.dataset.wblReady = 'true';

    const subscribedKey = 'wblClubSubscribed';
    const dismissedKey = 'wblClubDismissedAt';
    const dismissDays = Number(popup.dataset.dismissDays || 7);
    const delay = Number(popup.dataset.delaySeconds || 8) * 1000;
    const success = popup.querySelector('[data-wbl-success]')?.value === 'true';
    const email = popup.querySelector('#WinkyLashClubEmail');
    const form = popup.querySelector('#WinkyLashClubForm');
    const submit = popup.querySelector('[data-wbl-submit]');
    let previousFocus = null;

    const setLocked = (locked) => document.body.classList.toggle('wbl-club-lock', locked);
    const openPopup = () => {
      if (popup.open) return;
      previousFocus = document.activeElement;
      popup.showModal();
      setLocked(true);
      window.setTimeout(() => email?.focus(), 50);
    };
    const closePopup = (remember = true) => {
      if (!popup.open) return;
      if (remember) localStorage.setItem(dismissedKey, String(Date.now()));
      popup.close();
      setLocked(false);
      previousFocus?.focus?.();
    };

    if (success) {
      popup.classList.add('is-success');
      localStorage.setItem(subscribedKey, 'true');
      openPopup();
    } else if (!window.Shopify?.designMode && localStorage.getItem(subscribedKey) !== 'true') {
      const dismissedAt = Number(localStorage.getItem(dismissedKey) || 0);
      const dismissedRecently = dismissedAt && Date.now() - dismissedAt < dismissDays * 86400000;
      if (!dismissedRecently) window.setTimeout(openPopup, delay);
    }

    popup.querySelectorAll('[data-wbl-close]').forEach((button) => button.addEventListener('click', () => closePopup(true)));
    popup.querySelector('[data-wbl-continue]')?.addEventListener('click', () => closePopup(false));
    popup.addEventListener('click', (event) => { if (event.target === popup) closePopup(true); });
    popup.addEventListener('close', () => setLocked(false));
    form?.addEventListener('submit', () => {
      if (!submit) return;
      submit.disabled = true;
      submit.textContent = 'JOINING…';
    });
    popup.querySelector('[data-wbl-copy]')?.addEventListener('click', async (event) => {
      const button = event.currentTarget;
      const code = popup.querySelector('[data-wbl-code]')?.textContent?.trim() || 'WB10';
      try {
        await navigator.clipboard.writeText(code);
      } catch (_error) {
        const codeSelection = window.getSelection();
        const codeRange = document.createRange();
        codeRange.selectNodeContents(popup.querySelector('[data-wbl-code]'));
        codeSelection.removeAllRanges();
        codeSelection.addRange(codeRange);
      }
      const original = button.textContent;
      button.textContent = 'COPIED';
      window.setTimeout(() => { button.textContent = original; }, 2000);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initWinkyLashClubPopup, { once: true });
  } else {
    initWinkyLashClubPopup();
  }
  document.addEventListener('shopify:section:load', initWinkyLashClubPopup);

  } catch(e) { console.error(e); }
})();
})();
